// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7021":"css/app.6978","7652":"css/admin-app.6978"}[chunkId] + ".css";
};